export const setTotalProgress = (payload) => {
  return {
    type: '@progress/SET_TOTAL',
    payload,
  };
};

export const incrementProgress = () => {
  return {
    type: '@progress/INCREMENT',
  };
};

export const resetProgress = () => {
  return {
    type: '@progress/RESET',
  };
};